
export default ({ title, value, bg  }) => {
    return (
        <tr>
            <td valign="top" width="35%" className={"w-48 p-2 " + bg}>{ title }</td>
            <td valign="top" width="1%" className={"p-2 " + bg}>:</td>
            <td valign="top" className={" p-2 " + bg}> { value }</td>
        </tr>
    )
}